export const TYPES = {
  ProjectsService: Symbol('ProjectsService'),
  ProjectsRepository: Symbol('ProjectsRepository'),
  ProjectsFacade: Symbol('ProjectsFacade'),
  ProjectsStore: Symbol('ProjectsStore'),
  FontManager: Symbol('FontManager'),
};
